import React from "react";
import { render } from "react-dom";
import { Provider } from "react-redux";
import { PostHogProvider } from "posthog-js/react"
import App from "./pages/App";
import "./css";
import store from "./reduxstore/reduxStore";

const options = {
  api_host: process.env.POSTHOG_HOST,
}

render(
  <Provider store={store}>
    <PostHogProvider
      apiKey={process.env.POSTHOG_ID}
      options={options}
    >
        <App />
    </PostHogProvider>
  </Provider>,
  document.getElementById("container")
);
